import * as Tgcc from '../tgccGlobal'
import * as React from 'react'
import Radium, { StyleRoot } from 'radium'
import {CSSProperties} from 'react'
import {connect} from 'react-redux'



class LicProps extends Tgcc.BaseProps {
    license: Tgcc.License;
    selected: boolean;
    onChange?: (licenseid: number) => void;
}

const wrapperStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    width: '150px',
    margin: '20px',
    overflow: 'hidden',
    cursor: 'pointer'
};

const logoStyle: CSSProperties = {
    display: 'flex',
    margin: 'auto',
    maxWidth: '90%'
};

const captionStyle: CSSProperties={
    display: 'flex',
    whiteSpace: 'normal',
    textAlign: 'center',
    margin: '5px',
    fontFamily:'AveriaSerifLight',
    color:'#A6A6A6'
}

const licStyle: CSSProperties = {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    fontFamily:'CenturyGothic',
    fontSize: '13px',
    letterSpacing: '1px',
    fontWeight: "bold",
    whiteSpace: 'nowrap',
    textAlign: 'left',
    padding: '1px 5px',
    textTransform: 'none',
    backgroundColor: 'transparent'
};

let licStyleSelect = Object.assign({}, licStyle, {backgroundColor: Tgcc.Styles.grayHighlight});

export class _DesignLicense extends React.Component<LicProps, any> {
    
    state = {
        selected: false 
    }

    changeFilter = (license: Tgcc.License) => {
        if(this.props.onChange)
            this.props.onChange(license.id)
    } 
    
    handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingDesignImageSrc;
    }

    render() {
        
        var cStyle = this.props.selected ? licStyleSelect : licStyle;
        var caption = this.props.license.license;
        var logoImg = Tgcc.getLogoPath(this.props.license.thumbnail);
        return (
            <div style={wrapperStyle}>
                <div style={cStyle} onClick={this.doFilter}>
                    <img src={logoImg} style={logoStyle}  onError={this.handleImageError} alt={logoImg} />
                    <div style={captionStyle}>{caption}</div>
                </div>
            </div>
        )
    }

    doFilter = () => {
        if(this.props.selected)
            this.changeFilter(null);
        else 
            this.changeFilter(this.props.license)
    }
}

const mapStateToProps = (state: Tgcc.GlobalState, ownState: any) => {
    if(state && state.FilterDesignsByLicense && ownState.license)
        return { selected: ownState.license.Id == state.FilterDesignsByLicense };
    return {selected: false};
};
export var DesignLicense = connect(mapStateToProps)(Radium(_DesignLicense));

